export default function whatsapp(message: string, number?: string) {
  return `https://wa.me/${number || ''}?text=${encodeURIComponent(message)}`
}
